import { render, staticRenderFns } from "./viewOcorrenciasTransporte.vue?vue&type=template&id=7f5d3882&"
import script from "./viewOcorrenciasTransporte.vue?vue&type=script&lang=js&"
export * from "./viewOcorrenciasTransporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports